import React from "react"
import GitHubImages from "../components/GitHubImages"
import { Link } from "gatsby"

class Key extends React.PureComponent {
  showCurrentYear() {
    return new Date().getFullYear()
  }
  render() {
    return (
      <>
        <div className="slide-in-wrap left_slide-in-wrap left_menu_slide-in-wrap key theKey">
          <nav role="navigation">
            <div id="menuToggle">
              <input type="checkbox" />
              <div className="menuToggle-wrap">
                <div className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="text-next-to-hamburger">Key</div>
              </div>
              <ul id="menu">
                <div id="slide-in-wrap_menu-wrap">
                  <div id="left_menu_content">
                    <ul id="left_menu">
                      <h3 className="with-underline">Key</h3>

                      <div className="TierListKey_content">

                        <section>
                          <h3>Tier Rating Colors</h3>
                          <div className="TierRatingColors-wrap">
                            {/* <div className="fiveStar"><span>11.0 and up</span></div>
                            <div className="fourStar"><span>10 - 10.9</span></div> */}
                            <div className="fourStar"><span>10 and up</span></div>
                            <div className="threeStar"><span>8 - 9.9</span></div>
                            <div className="twoStar"><span>6 - 7.9</span></div>
                            <div className="oneStar"><span>4 - 5.9</span></div>
                            <div className="noStar"><span>1 - 3.9</span></div>
                          </div>
                        </section>

                        <section>
                          <h6>Book Value Indicators</h6>
                          <p className="Bookline">
                              <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="Books" whichImage="Skillbook_Rare" height="30px" title="Book Value of 6 or 7" alt="Book Value of 6 or 7" /> 6 or 7
                          </p>
                          <p className="Bookline">
                              <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="Books" whichImage="Skillbook_Epic" height="30px" title="Book Value of 8 or 9" alt="Book Value of 8 or 9" /> 8 or 9
                          </p>
                          <p className="Bookline">
                              <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="Books" whichImage="Skillbook_Legendary" height="30px" title="Book Value of 10" alt="Book Value of 10" /> 10
                          </p>
                          <p className="Bookline">
                              <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG semi-transparent" whichDirectory="Books" whichImage="Skillbook_Rare" height="30px" title="Book Value of 5 or lower" alt="Book Value of 5 or lower" /> 5 or lower
                          </p>
                          <p className="caption small">(If I have not added a book rating for a champ yet, nothing will be displayed.)</p>
                        </section>

                        <section>
                          <h6 className="mb-2">Damage Based On Indicators</h6>
                          <div className="DamageBasedOnIndicators-wrap">
                            <div className="key-damageBasedOn-img-wrap">
                              <div className="hit-damageBasedOn-img-wrap Attack">
                                <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="ItemSetIcons" whichImage="Offense" title="Damage Based On Attack" alt="Damage Based On Attack" />
                              </div>
                              <span className="caption small">Attack</span>
                            </div>
                            <div className="key-damageBasedOn-img-wrap">
                              <div className="hit-damageBasedOn-img-wrap Defense">
                                <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="ItemSetIcons" whichImage="Defense" title="Damage Based On Defense" alt="Damage Based On Defense" />
                              </div>
                              <span className="caption small">Defense</span>
                            </div>
                            <div className="key-damageBasedOn-img-wrap">
                              <div className="hit-damageBasedOn-img-wrap HP">
                                <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="ItemSetIcons" whichImage="Life" title="Damage Based On HP" alt="Damage Based On HP" />
                              </div>
                              <span className="caption small">HP</span>
                            </div>
                            <div className="key-damageBasedOn-img-wrap">
                              <div className="hit-damageBasedOn-img-wrap N-A">
                                <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="ItemSetIcons" whichImage="Curing" title="Support champs that doesn't do damage" alt="Support champs that doesn't do damage" />
                              </div>
                              <span className="caption small">N/A</span>
                            </div>
                          </div>
                        </section>

                        <section>
                          <h6>Farmable Indicator</h6>
                          <GitHubImages whichTopLevel="AvatarIconImages" className="inlineIMG" whichDirectory="AvatarIconImages/RaidChamps" whichImage="farmable" title="Farmable Champion" alt="Farmable Champion" />
                          {/* <p className="caption small">To easily see which champions are farmable, look for this icon just below the top right corner of their image if they are farmable. When hovering over this icon it will tell you where they can be farmed.</p> */}
                        </section>

                        <p className="moreInfoLink-wrap">
                          <Link to="/news/new-way-to-view-my-tier-list">Click here to read more about how the tier list works.</Link>
                        </p>

                      </div>


                      <div className="ChampPageKey_content">

                        <section>
                          <h3>Tier Rating Colors</h3>
                          <div className="TierRatingColors-wrap">
                            <div className="fiveStar">{/* <p className="Legendary"></p> */}<span>11-12 Super Meta</span></div>
                            <div className="fourStar">{/* <p className="Epic"></p> */}<span>9-10 Excellent</span></div>
                            <div className="threeStar">{/* <p className="Rare"></p> */}<span>7-8 Good</span></div>
                            <div className="twoStar">{/* <p className="Uncommon"></p> */}<span>6-7 Decent</span></div>
                            <div className="oneStar">{/* <p className="Common"></p> */}<span>4-5 Average</span></div>
                            <div className="noStar">{/* <p className="Bad"></p> */}<span>1-3 Bad</span></div>
                          </div>
                        </section>

                      </div>
                      
                    </ul>
                  </div>
                </div>
              </ul>
            </div>
          </nav>
        </div>
      </>
    )
  }
}

export default Key
